<template>
  <v-container style="padding-top: 100px;">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card class="mx-auto" width="98%"
          style="background-image: url('https://www.ausa.com.mx/img/fondoPS.jpg'); background-repeat: repeat-x; height: 18rem;">
          <v-container>
            <v-card-title class="white--text mt-8" align-center>
              <v-row align="center" style="text-align:center" justify="center" justify-content-center>
                <v-col cols="12" sm="6" md="6" width="100%">
                  <v-avatar size="62" color="#536DFE">
                    <v-icon dark>mdi-human-greeting</v-icon>
                  </v-avatar>
                  <p class="ml-3" style="color:white; font-weight: bold; -webkit-text-stroke: 0.8px #000000;">
                    {{ this.nombre }}
                  </p>
                </v-col>
                <v-col cols="12" sm="6" md="6" width="100%">
                  <v-avatar size="62" color="#FF5C93">
                    <v-icon dark>mdi-bag-checked</v-icon>
                  </v-avatar>
                  <p class="ml-3" style="color:white; font-weight: bold; -webkit-text-stroke: 0.8px #000000;">
                    {{ this.cliente }}
                  </p>
                </v-col>
              </v-row>
            </v-card-title>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md7 mt-2>
        <v-card class="mx-auto mr-3 ml-3" width="100%">
          <v-card-title class="justify-center primary">
            <v-toolbar-title id="titulocard">Cambio de Contraseña</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon :color="'#FFFFFF'">mdi-form-textbox-password</v-icon>
          </v-card-title>
          <v-card-text>
            <span style="font-size:16px" id="password">
              La contraseña es de carácter personal, por lo cual deberá
              ser una clave difícil, pero al mismo tiempo fácil de recordar.
            </span>
            <v-alert border="right" colored-border type="error" elevation="2" class="mt-2">
              El resguardo de esta es totalmente responsabilidad del usuario, por lo cual no
              se debe prestar a nadie, ya que el sistema está auditado con base en la misma, si
              hay alguna anomalía se puede detectar con facilidad, por lo cual los hace responsables
              de su uso.
            </v-alert>
            <div>
              <vs-list>
                <vs-list-item class="lista" style="color:#536DFE "
                  subtitle="Evitar poner números seguidos 1234."></vs-list-item>
                <vs-list-item class="lista" style="color:#536DFE "
                  subtitle="Evitar poner letras continuas AABBaacc."></vs-list-item>
                <vs-list-item class="lista" style="color:#536DFE "
                  subtitle="Evitar utilizar palabras comunes o albures."></vs-list-item>
              </vs-list>
              <vs-list>
                <vs-list-item style="font-size:16px !important" class="lista" id="caracteres"
                  subtitle="Debe tener un mínimo de 8 caracteres y un máximo de 16 caracteres.">
                </vs-list-item>
                <vs-list-item class="lista" id="fortaleza"
                  subtitle="Debe tener un mínimo de grado de fortaleza de 70%.">
                </vs-list-item>
                <vs-list-item class="lista" id="numero" subtitle="Deberá de contener números (0 … 9).">
                </vs-list-item>
                <vs-list-item class="lista" id="letras" subtitle="Letras en mayúsculas y minúsculas (a… z, A… Z).">
                </vs-list-item>
                <vs-list-item class="lista" id="sCaracter"
                  subtitle="Por lo menos un carácter especial de los permitidos (#$%&/()?_!.*\@@+:,).">
                </vs-list-item>
                <vs-list-item class="lista" id="nCaracteres"
                  subtitle="Caracteres NO PERMITIDOS (<,>,-,^,',=,ñ,Ñ,{,},;).">
                </vs-list-item>
              </vs-list>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md5 mt-2>
        <v-card class="mx-auto mr-3 ml-3" width="100%">
          <v-card-text style="margin-top: 20px;">
            <v-form v-model="valid" lazy-validation ref="formreporte" mt-3 style="margin:5px">
              <v-label>Ingrese su contraseña actual</v-label>
              <v-text-field v-model="passactual" outlined persistent-hint
                :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'" :counter="16" @click:append="() => (value = !value)"
                :type="value ? 'text' : 'password'" :rules="passwordRules" maxlength="16"
                @keydown.space.prevent></v-text-field>

              <v-label>Ingrese su nueva contraseña</v-label>
              <v-text-field v-model="passnueva" outlined persistent-hint :rules="passwordRules"
                :append-icon="valuepassn ? 'mdi-eye' : 'mdi-eye-off'" :counter="16"
                @click:append="() => (valuepassn = !valuepassn)" :type="valuepassn ? 'text' : 'password'" maxlength="16"
                @keydown.space.prevent></v-text-field>
              <v-label>Repita su nueva contraseña</v-label>
              <v-text-field v-model="passnuevar" outlined persistent-hint :rules="passwordRules"
                :append-icon="valuepassr ? 'mdi-eye' : 'mdi-eye-off'" :counter="16"
                @click:append="() => (valuepassr = !valuepassr)" :type="valuepassr ? 'text' : 'password'" maxlength="16"
                @keydown.space.prevent></v-text-field>

              <v-progress-linear :color="color" height="20" v-if="custom" :value="progress">
                <strong>{{ this.progress }}%</strong>
              </v-progress-linear>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
            <div mt-2 style="text-align: center;">
              <v-btn class="mr-4 mt-3" color="success" @click="RestablecerPass">Restablecer</v-btn>
              <v-btn v-if="btncancelar" class="mr-4 mt-3" color="secondary" @click="Cancelar">Cancelar</v-btn>
              <v-btn class="mr-4 mt-3" color="default" @click="limpiar">Limpiar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import LocalStorage from '@/utils/managerLocalStorage.js';
import Inicio from '@/services/main/main.service.js';

export default {

  data: () => ({
    colorinicial: '',
    caracteres: false,
    fortaleza: false,
    numero: false,
    letras: false,
    sCaracter: false,
    nCaracteres: false,
    passactual: '',
    passnueva: '',
    passnuevar: '',
    nombre: '',
    cliente: '',
    userPassword: "",
    valid: true,
    value: true,
    valuepassn: false,
    valuepassr: false,
    contador: 0,
    value: '',
    custom: true,
    passwordRules: [
      v => !!v || 'Se requiere contraseña',
      v => (v && v.length >= 8) || 'La contraseña debe tener más de 8 caracteres',
      v => (v && v.length <= 16) || 'La contraseña debe tener igual o menos de 16 caracteres',
      v => /(?=.*[A-Z])/.test(v) || 'Debe tener un carácter en mayúsculas',
      v => /(?=.*\d)/.test(v) || 'Debe tener un número',
      v => /([#$%&/()?_!.*@+:,])/.test(v) || 'Debe tener un carácter especial [#$%&/()?_!.*@+:,]',
    ],
    caduco: true,
    btncancelar: true,
    local: ''
  }),
  watch: {
    'passnueva'(val) {
      switch (val.length >= 8) {
        case (true):
          this.caracteres = true
          document.getElementById('caracteres').style.color = "#3CD4A0";
          break;
        case (false):
          this.caracteres = false;
          document.getElementById('caracteres').style.color = this.colorinicial;
          break;
      }
      switch (!MetodosGenerales.validarRegex(val, "NU")) {
        case (true):
          this.numero = true
          document.getElementById('numero').style.color = "#3CD4A0";
          break;
        case (false):
          this.numero = false;
          document.getElementById('numero').style.color = this.colorinicial;
          break;
      }
      switch (!MetodosGenerales.validarRegex(val, "LT")) {
        case (true):
          this.letras = true
          document.getElementById('letras').style.color = "#3CD4A0";
          break;
        case (false):
          this.letras = false;
          document.getElementById('letras').style.color = this.colorinicial;
          break;
      }
      switch (!MetodosGenerales.validarRegex(val, "SC")) {
        case (true):
          this.sCaracter = true
          document.getElementById('sCaracter').style.color = "#3CD4A0";
          break;
        case (false):
          this.sCaracter = false;
          document.getElementById('sCaracter').style.color = this.colorinicial;
          break;
      }
      switch (!MetodosGenerales.EvaluarInvalidos(val)) {
        case (true):
          this.nCaracteres = true
          document.getElementById('nCaracteres').style.color = "#3CD4A0";
          break;
        case (false):
          this.nCaracteres = false;
          document.getElementById('nCaracteres').style.color = this.colorinicial;
          break;
      }
      if (val.length == 0) {
        this.nCaracteres = false
        document.getElementById('nCaracteres').style.color = this.colorinicial;
      }
    },
    'fortaleza'(val) {
      if (val) {
        document.getElementById('fortaleza').style.color = "#3CD4A0";
      } else {
        document.getElementById('fortaleza').style.color = this.colorinicial;

      }
    },
    'local'() {
      this.colorinicial = this.local.nocturno == true ? 'white' : 'black'
      document.getElementById('password').style.color = this.colorinicial;
      if (this.caracteres == false) {
        document.getElementById('caracteres').style.color = this.colorinicial;
      }
      if (this.numero == false) {
        document.getElementById('numero').style.color = this.colorinicial;
      }
      if (this.letras == false) {
        document.getElementById('letras').style.color = this.colorinicial;
      }
      if (this.sCaracter == false) {
        document.getElementById('sCaracter').style.color = this.colorinicial;
      }
      if (this.sCaracter == false) {
        document.getElementById('sCaracter').style.color = this.colorinicial;
      }
      if (this.nCaracteres == false) {
        document.getElementById('nCaracteres').style.color = this.colorinicial;
      }
      if (this.fortaleza == false) {
        document.getElementById('fortaleza').style.color = this.colorinicial;
      }
    }
  },
  //document.getElementById('caracteres').style.color = "primary";
  computed: {
    ...mapState({ drawer: state => state.drawer }),
    ...mapState(['domain', 'informationPage']),
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
    },
    progress() {
      var porcentajeSeguridad = MetodosGenerales.ValidarPass(this.passnueva);
      return porcentajeSeguridad
    },
    color() {
      var colorprogress = ''
      if (this.progress == 0) {
        colorprogress = '#CECCCE'
        this.fortaleza = false;
      } else if (this.progress < 35) {
        colorprogress = 'error'
        this.fortaleza = false;
      } else if (this.progress < 70 && this.progress >= 35) {
        colorprogress = 'warning'
        this.fortaleza = false;
      } else if (this.progress >= 70) {
        colorprogress = 'success'
        this.fortaleza = true;
      }
      return colorprogress
    },
  },
  methods: {
    ...mapActions(['TOGGLE_DRAWER']),
    async obtenerNombre() {
      let response = await Inicio.ObtenerNombre(this);
      this.nombre = response;
    },
    async obtenerCliente() {
      let response = await Inicio.ObtenerClienteGrupo(this);
      this.cliente = response;
    },
    async RestablecerPass() {
      this.$refs.formreporte.validate()
      if (this.$refs.formreporte.validate() != false) {
        if (this.passnueva !== this.passactual) {
          if (this.passnueva === this.passnuevar) {
            if (this.nCaracteres) {
              if (this.progress >= 70) {
                this.$swal({
                  position: 'center',
                  title: 'Actualizando contraseña, espere un momento...',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  didOpen: () => {
                    this.$swal.showLoading();
                  }
                });
                let respuesta = await Inicio.Comprobarpassword(this, this.passactual, this.passnueva);
                if (respuesta.data != "") {
                  this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Error',
                    text: respuesta.data,
                    showConfirmButton: true,
                    allowOutsideClick: false
                  });
                } else {
                  this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Constraseña actualizada.',
                    text: 'La contraseña ha sido actualizada correctamente.',
                    showConfirmButton: true,
                    confirmButtonColor: '#3CD4A0',
                    allowOutsideClick: false
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      let password = {
                        tipo: 'OK',
                        mensaje: null
                      };
                      await MetodosGenerales.guardarEnSesionInfoReporte(password, 'password');
                      this.$router.push({ name: "index" })
                      location.reload();
                    }
                  });
                }
              } else {
                this.$swal({
                  position: 'center',
                  icon: 'warning',
                  title: 'Error',
                  text: 'El nivel mínimo de seguridad es de 70%',
                  showConfirmButton: true,
                  allowOutsideClick: false,
                });
              }
            } else {
              this.$swal({
                position: 'center',
                icon: 'warning',
                title: 'Error',
                text: 'La nueva contraseña contiene carácteres no válidos, favor de verificarlo.',
                showConfirmButton: true,
                allowOutsideClick: false,
              });
            }
          } else {
            this.$swal({
              position: 'center',
              icon: 'warning',
              title: 'Error',
              text: 'La nueva contraseña y la confirmación no coinciden, favor de verificarlo',
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          }
        } else {
          this.$swal({
            position: 'center',
            icon: 'warning',
            title: 'Error',
            text: 'La contraseña actual y la nueva contraseña son iguales.',
            howConfirmButton: true,
            allowOutsideClick: false,
          });
        }
      }
    },
    limpiar() {
      this.$refs.formreporte.reset();
      this.passactual = ''
      this.passnueva = ''
      this.passnuevar = ''
      this.nCaracteres = false
    },
    Cancelar() {
      this.$router.push({ name: "index" })
    }
  },
  async mounted() {
    this.obtenerNombre();
    this.obtenerCliente();
    let password = await MetodosGenerales.obtenerSessionReporte('password');
    if (password.tipo == 'O' || password.tipo == 'N') {
      let titulo = password.tipo == 'O' ? 'Contraseña expirada' : 'Bienvenido'
      this.$swal({
        position: 'center',
        icon: 'warning',
        title: titulo,
        text: password.mensaje,
        showConfirmButton: true,
        confirmButtonText: "De acuerdo.",
        confirmButtonColor: '#3CD4A0',
        allowOutsideClick: false,
      });
      this.btncancelar = false;
    }
  },
  updated() {
    this.local = LocalStorage.getSingleValueInLocalStorage("tema");
  }
}
</script>
<style>
.lista .vs-list--subtitle {
  font-size: 16px !important;
}
</style>